import React, { ReactNode } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { usePageTracking } from '../hooks/use-page-tracking';
import LendoHeader from './LendoHeader';
import { LendoFooter } from './LendoFooter';

interface LendoAppWrapperProps {
  basename: string;
  children: ReactNode;
  useLayout?: boolean;
}

const queryClient = new QueryClient();

const AppContent = ({ children, useLayout }: { children: ReactNode; useLayout?: boolean }) => {
  usePageTracking();

  if (useLayout) {
    return (
      <div className="min-h-screen flex flex-col">
        <LendoHeader />
        <main className="flex-grow">{children}</main>
        <LendoFooter />
      </div>
    );
  }

  return (
    <>
      <LendoHeader />
      {children}
      <LendoFooter />
    </>
  );
};

const LendoAppWrapper = ({ basename, children, useLayout = false }: LendoAppWrapperProps) => {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter
        basename={basename.replace(/\/$/, '')}
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <AppContent useLayout={useLayout}>{children}</AppContent>
      </BrowserRouter>
    </QueryClientProvider>
  );
};

export default LendoAppWrapper;
